// <editor-fold defaultstate="collapsed" desc="imports">
import React from "react";
import {observer} from 'mobx-react';
import {computed, observable} from 'mobx';
import {CircularProgress} from "@mui/material";

import Form from 'utils/Form';
import {ShouldUpdate} from 'utils/Utils';

import {ClearableInput, SelectEmployeeInput, UploadButton} from 'components/inputs';
import {FormControls, Row} from 'components/FormComponents';

import {AEditDialog} from 'components/dialogs';

import style from "./EditDialog.lazy.css";
import {updateEmployeeCompetency} from "mutations/update";
import {findByIdEmployeeCompetency} from "mutations/findById";
import SelectTrainingCourseInput from "../../../../../components/inputs/SelectTrainingCourseInput";
// </editor-fold>

// <editor-fold defaultstate="collapsed" desc="Dialog">
@observer
class EditCompetencyCertificateDialog extends AEditDialog {
    pageKey = "EditCompetencyCertificateDialog";
    className = "AEditEmployeeDocDialog";
    title = "Edit Competency Certificate";
    removeById = updateEmployeeCompetency;

    constructor(props) {
        super(props, style);
    }

    get findById() {
        const {props: {isNewEmployee}} = this;
        if (isNewEmployee) return;
        return findByIdEmployeeCompetency;
    }

    get topButtonsHiddenDelete() {
        const {props: {isNewEmployee}} = this;
        if (isNewEmployee) return true;
    }

    get controls() {
        return Controls;
    }
}

// </editor-fold>

@observer
class Controls extends React.Component {
    path = "plugin_sheq_assist/employees/competencies/";

    // <editor-fold defaultstate="collapsed" desc="fields">
    @observable
    state = {
        lists: {
            type: [{text: "Accredited", value: "Accredited", checked: false}, {
                text: "Non-Accredited",
                value: "Non-Accredited",
                checked: false
            }],
            competency_type: ['Behavioural', 'Technical / Functional', 'Leadership']
        },
        trainer: null
    };
    // </editor-fold>

    // <editor-fold defaultstate="collapsed" desc="constructor">
    constructor(props) {
        super(props);

        this.onNext = this.onNext.bind(this);
        this.onFormSave = this.onFormSave.bind(this);

        this.form = new Form();
        this.form.addChangeOne("course", this.onChangeCourse.bind(this));
        this.form.addChangeOne("training", this.onChangeTraining.bind(this));
    }

    // </editor-fold>

    get isNewEmployee() {
        const {props: {dialog: {props: {isNewEmployee}}}} = this;
        return isNewEmployee;
    }

    // </editor-fold>

    @computed
    get item() {
        return this.props.state.item;
    }

    // </editor-fold>

    // <editor-fold defaultstate="collapsed" desc="onChangeCourse">
    onChangeCourse(el, val) {
        if (val) {

        }
    }

    // <editor-fold defaultstate="collapsed" desc="onChangeTraining">
    onChangeTraining(el, val) {
        if (val) {
            const {hr} = val.data;
            this.state.trainer = hr;
        }
    }

    // </editor-fold>

    // <editor-fold defaultstate="collapsed" desc="onNext">
    onNext(e, btn) {
        const {form, isNewEmployee, props: {dialog: {props: {embeddedEmployee}}}} = this;
        const {idx} = btn.props;
        if (idx === 1) {
            if (!isNewEmployee && !embeddedEmployee && !form.isValid('employee')) {
                infoDialog.open('Employee is required');
                return;
            }
        }
        if (idx === 2) {
            if (!form.isValid('competency_type')) {
                infoDialog.open('Competency Type is required');
                return;
            }
        }

        return true;
    }

    //<editor-fold desc="onFormSave">
    async onFormSave(e, btn) {
        const {
            form,
            isNewEmployee,
            item: {id, data: old_data},
            props: {dialog: {props: {embeddedEmployee}}},
        } = this;

        const {is: {isContractor}, loggedContractor} = storage;

        const onSubmit = (data, onSaved) => {
            if (Object.keys(data).isEmpty()) {
                infoDialog.open("Nothing changed!");
                return;
            }

            console.log(data)

            btn.text("Saving...").disabled();
            progressDialog.open();
            updateEmployeeCompetency({id: this.item.id, ...data}).then(res => {
                console.log("res", res)
                const res_data = res;
                onSaved && onSaved(res_data);
                infoDialog.open("Record successfully updated.");
                infoDialog.close(2000);
                // this.props.close();
            }).finally(() => {
                btn.text("Save").enabled();
                setTimeout(() => progressDialog.close());
            });
        };

        const {idx} = btn.props;

        if (idx === 1) {
            if (!isNewEmployee && !embeddedEmployee && !form.isValid('employee')) {
                infoDialog.open('Employee is required');
                return;
            }

            const {
                employee,
            } = form.data;

            const data = {};

            if (!embeddedEmployee) {
                ShouldUpdate.checkEmployee(data, old_data, employee, 'employee_id');
            }

            onSubmit(data);
            return;
        }

        if (idx === 2) {
            if (!form.isValid('competency_type')) {
                infoDialog.open('Competency Type is required');
                return;
            }

            const {
                //2
                issued_date, expiry_date,
                type, competency_type,
                accreditation_num,
                certificate_num,
                course,
                training,
            } = form.data;

            let data = {};

            ShouldUpdate.checkDate(data, old_data, issued_date, 'issued_date');
            ShouldUpdate.checkDate(data, old_data, expiry_date, 'expiry_date');
            ShouldUpdate.check(data, old_data, type, 'type');
            ShouldUpdate.check(data, old_data, competency_type, 'competency_type');
            ShouldUpdate.check(data, old_data, accreditation_num, 'accreditation_num');
            ShouldUpdate.check(data, old_data, certificate_num, 'certificate_num');
            ShouldUpdate.checkCourseOrModule(data, old_data, course, 'course_id');
            ShouldUpdate.checkTrainingMatrix(data, old_data, training, 'training_id');

            onSubmit(data);
            return;

        }

        if (idx === 3) {
            if (!form.isValid('doc')) {
                infoDialog.open('Please Upload Competency Certificate');
                return;
            }

            const {
                doc,
            } = form.data;

            const data = {};

            ShouldUpdate.checkFile(data, old_data, doc, 'doc');

            onSubmit(data);
            return;
        }

        return true;
    }

    // <editor-fold defaultstate="collapsed" desc="onSubmit">
    onSubmit(e, btn, onSaved) {
        const {form, isNewEmployee, item: old_data, props: {dialog: {props: {embeddedEmployee}}}} = this;

        //1
        if (!isNewEmployee && !embeddedEmployee && !form.isValid('employee')) {
            infoDialog.open('Employee is required');
            return;
        }
        // 2
        if (!form.isValid('competency_type')) {
            infoDialog.open('Competency Type is required');
            return;
        }
        //3
        if (!form.isValid('doc')) {
            infoDialog.open('Please Upload Competency Certificate');
            return;
        }

        console.log("res", form.data)
        onSaved && onSaved(form.data);
        infoDialog.open("Record added.");
        infoDialog.close(2000);
        this.props.close();
    }

    // <editor-fold defaultstate="collapsed" desc="render">
    render() {
        if (!this.item) {
            return <CircularProgress className="fixed-center"/>;
        }

        let {
            props: {
                onFormNext, onFormBack, onFormOpen,
                dialog: {props: {embeddedEmployee, isNewEmployee,}}
            },
            item, item: {
                id,
                data: {
                    created_at,
                    employee,
                    title,
                    course,
                    training,
                    trainer,
                    type,
                    competency_type,
                    issued_date,
                    expiry_date,
                    accreditation_num,
                    certificate_num,
                    doc
                }
            },
        } = this;
        return <FormControls>
            {!isNewEmployee && !embeddedEmployee && <Row
                rendered
                active
                idx={1}
                title="1. Employee"
                onFormOpen={onFormOpen}
                onFormNext={onFormNext}
                onFormSave={!isNewEmployee && this.onFormSave}
            >
                <SelectEmployeeInput
                    name="employee"
                    placeholder="Employee..."
                    defaultValue={employee}
                    className="col-lg-12 form-control"
                    onChange={this.form.onChange}
                />
            </Row>}
            <Row
                rendered
                active
                idx={1}
                title="1. Competency Details"
                onFormOpen={onFormOpen}
                onFormNext={onFormNext}
                onFormSave={!isNewEmployee && this.onFormSave}
            >
                <ClearableInput name="issued_date" type="date" placeholder="Date Of Issue..." defaultValue={issued_date}
                                required className="col-lg-6 form-control" onChange={this.form.onChange}/>
                <ClearableInput name="expiry_date" type="date" placeholder="Expiry Date..." defaultValue={expiry_date}
                                className="col-lg-6 form-control" onChange={this.form.onChange}/>
                <ClearableInput name="type" type="radio" placeholder="Certificate Type" defaultValue={type} required
                                desc="Accredited: (officially recognized and meets industry standards) or Non-Accredited: (informal or internal certification without official recognition)."
                                className="col-lg-12 form-control" onChange={this.form.onChange}
                                values={this.state.lists.type}/>
                <ClearableInput name="competency_type" type="select" placeholder="Competency Type..."
                                desc="Behavioural: (soft skills and personal attributes), Technical / Functional: (job-specific skills and knowledge), or Leadership: (skills for managing and guiding teams or organizations)."
                                defaultValue={competency_type} required className="col-lg-6 form-control"
                                onChange={this.form.onChange} values={this.state.lists.competency_type} returnValue
                                add/>
                <ClearableInput name="accreditation_num" type="text" placeholder="Accreditation Number"
                                defaultValue={accreditation_num} required className="col-lg-6 form-control"
                                onChange={this.form.onChange}/>
                <ClearableInput name="certificate_num" type="text" placeholder="Certificate Number"
                                defaultValue={certificate_num} required className="col-lg-6 form-control"
                                onChange={this.form.onChange}/>
            </Row>
            <Row
                rendered
                idx={2}
                title="2. Training Details"
                onFormOpen={onFormOpen}
                onFormBack={onFormBack}
                onFormNext={onFormNext}
                onFormSave={!isNewEmployee && this.onFormSave}
            >
                <SelectTrainingCourseInput name="course" defaultValue={course} required
                                           className="col-lg-12 form-control"
                                           onChange={this.form.onChange}/>
                {/*<SelectTrainingMatixInput name="training" defaultValue={training} required*/}
                {/*                          className="col-lg-12 form-control"*/}
                {/*                          onChange={this.form.onChange}/>*/}
                <Trainer state={this.state}/>
            </Row>
            <Row
                rendered
                idx={3}
                title="3. Certificate Details"
                onFormOpen={onFormOpen}
                onFormBack={onFormBack}
                onFormSave={!isNewEmployee && this.onFormSave}
            >
                <UploadButton
                    name="doc"
                    buttonTitle="Upload File (PDF, Word or Photo)"
                    type={['PDF', 'Word', 'Image']}
                    defaultValue={doc}
                    showOnlyIcon
                    className="col-lg-12"
                    onChange={this.form.onChange}
                />
            </Row>
        </FormControls>;
    }

    // </editor-fold>
}

// <editor-fold defaultstate="collapsed" desc="Trainer">
@observer
class Trainer extends React.Component {

    render() {
        const {state: {trainer}} = this.props;
        if (!trainer) return null;
        return <div className="Trainer row">
            <label className="hor-center">Trainer</label>
            <div>{trainer.lname + ' ' + trainer.fname}</div>
        </div>;
    }
}

// </editor-fold>

export default EditCompetencyCertificateDialog;
